import React from 'react'
import './apropos.css'

export const  Apropos = () => {
    
    return (
        <>
        
        <div className="containerApropos">
            <div className="column">
               <img src="png-green.png" alt="pic" /> 
            </div>
       <div className="column">
            <span className="txtPrincipal">QUI SOMMES NOUS?</span>
            <hr/> <br/>
            <div className="containe">
            <span className="txtTitre">NOS VALEURS</span><br/>
            <span>GREEN LOGISTICS est un commissionnaire en douane agrée, spécialiste et conseil
            en matière de législation, d'opérations de dédouanement, et de transport
            terrestre, maritime et aérien.</span>
            </div><br/>
            <div className="containe">
            <span className="txtTitre">NOTRE MISSION</span><br/>
            <span>Nous avons pour mission 'Le Service' Un service efficace, rapide, et intelligent pour
            assurer à nos clients la quiétude de se consacrer à leurs activités principales</span>
            </div><br/>
            <div className="containe">
            <span className="txtTitre">NOS REFERENCES</span>
            <br/>
            <span>Nos valeurs sont: nos clients, nos collaborateurs et tous nos partenaires. C'est
            grâce à VOUS que nous sommes 'NOUS'</span>
            </div>
            <br/>
            <div className="containe">
            <span className="txtTitre">NOTRE EQUIPE</span><br/>
            <span>Grâce à notre équipe pluridisciplinaire constituée de techniciens chevronnés, nous
            sommes en mesure de gérer efficacement et dans les délais toutes les opérations
            de dédouanement import et export.</span>
            </div>
            <br/><br/>
            <span className="downplaq">TELECHARGER LA PLAQUETTE</span><br/>
        </div>
            </div>
            </>
    )
  }